import React from "react";
import Tabs from "./components/tabs/tabs";
import home_active from './assets/images/home_icn.png'
import home_inactive from './assets/images/hme_gry.png'
import msg_active from './assets/images/msg_blu.png'
import msg_inactive from './assets/images/messages_icn.png'
import HomeWorkPdf from "./modules/common/home-work-pdf";
/**
 * it's a Props we receive from module
 */

/**
 *
 * @param  {Props} from the api
 * @return {Tabs} global component
 */
export default function TestComponent() {
  return (
    <>
    <Tabs
    onClick={(e:any) => {console.log(e)}}
    selectedTab={2}
    labels={
        [
            {
                tab:1,
                name: 'Home',
                activeImg:<img src={home_active} alt="..." className="" width="15px" height="15px" />,
                inActiveImg:<img src={home_inactive} alt="..." className="" width="15px" height="15px" />            },
            {
                tab:2,
                name: 'Messages',
                activeImg:<img src={msg_active} alt="..." className="" width="15px" height="15px" />,
                inActiveImg:<img src={msg_inactive} alt="..." className="" width="15px" height="15px" />
            }
        ]
    }
    />
    <HomeWorkPdf />
    </>
  );
}
